import {
  EMPTY_RESULT,
  formatScoreWithUnit,
  getEffectiveEvaluationResult,
  getExpertReportResultText,
} from '@/entities/expert-report';

/** Результат строки заключения: чем оценены блок или итог и что из этого выставил пользователь */
export type EvaluationRowResult = {
  /** Балл, рассчитанный системой; null — блок оценён значением справочника */
  rating: number | null;
  maxRating: number | null;
  /** Балл, выставленный пользователем; null — балл не выставлялся */
  manualRating: number | null;
  /** Значение, полученное системой; null — результат блока оказался баллом */
  value: string | null;
  /** Набор значений, собранный правилом расчёта; null — результат не набор */
  values: string[] | null;
  /** Значение, выбранное пользователем; null — значение не выбиралось */
  manualValue: string | null;
  /** Числовая часть шкалы блока; не null только у блока, шкала которого несёт и баллы, и справочник */
  possiblePoints: number[] | null;
  /** Справочник, из которого выбирается значение блока; null — справочника у блока нет */
  possibleValues: string[] | null;
  /** Размерность балла; null — размерность не определена или результат не балл */
  unit: string | null;
};

/**
 * Текст результата строки заключения — тот же, что стоит в ней без правки: набор значений
 * перечислением, значение справочника, балл с максимумом и размерностью либо прочерк.
 *
 * Какой из результатов записи действует, решает сама сущность ({@link getEffectiveEvaluationResult}):
 * второй разбор тех же полей разошёлся бы с показанным в строке — у блока с совмещённой шкалой
 * выставленный балл старше полученного значения. Здесь остаётся только вид: максимум стоит у балла,
 * которому он известен.
 *
 * Тем же текстом результат меряется на умещение ({@link useTotalRowFit}), поэтому вид его задаёт
 * одна эта функция, а не разметка каждого места показа.
 */
export const getEvaluationRowResultText = (result: EvaluationRowResult): string => {
  const effective = getEffectiveEvaluationResult(result);
  if (effective.score != null && effective.maxScore != null) {
    return formatScoreWithUnit(effective.score, effective.maxScore, effective.unit);
  }
  return getExpertReportResultText(effective) ?? EMPTY_RESULT;
};
